<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="this.$t('CargoMsg.Cargo_NewTo')"
      width="380px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="80px" label-position="left">
          <el-form-item :label="this.$t('CargoMsg.Cargo_Carrier')">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
              :default-value="form.carrierId||''"
              :callback-params="{key:'carrierId'}"
              @parentCallBack="p => getValueFromChild(p)"
            />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_BookingAgent')">
            <cargo-advance-select
              filterable
              :method-params="{bookingAgent:true}"
              :select-type="selectTypeNames.basic_data_Company"
              :default-value="form.bookingAgent === 0 ? '': form.bookingAgent"
              @parentCallBack="p=>form.bookingAgent=p.cmpIdx"
            />
          </el-form-item>

          <el-form-item :label="this.$t('CargoMsg.Cargo_GenerativeRule')">
            <el-select v-model="form.generativeRule">
              <el-option
                v-for="(item,index) in generativeRules"
                :key="index"
                :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_StartNumber')">
            <el-input v-model="form.starNo" no="starNo" />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_EndNumber')">
            <el-input v-model="form.endNo" no="endNo" @change="endNoChangeHandler" />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_TotalCopies')">
            <el-input-number v-model="form.number" :min="0" :max="2000" style="width: 200px;" controls-position="right" @change="numberChangeHandler" />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_AdditionalRemark')">
            <el-input v-model="form.remark" no="remark" length="100" type="textarea" :rows="3" />
          </el-form-item>
          <el-form-item v-if="form.generativeRule === SystemConstants.GENERAL.code" :label="this.$t('CargoMsg.Cargo_ApplicableBranch')" :disabled="false">
            <cargo-advance-select
              no="branchId"
              :select-type="selectTypeNames.basic_data_Office_All"
              :clearable="false"
              filterable
              :default-value="form.branchId||''"
              :cache="false"
              :static-options="officeList"
              :placeholder="' '"
              @parentCallBack="p => handleCompany(p)"
            />
          </el-form-item>
          <el-form-item v-if="form.generativeRule === SystemConstants.FIXED_LAST_NUMBER.code" :label="this.$t('CargoMsg.Cargo_ApplicableBranch')" :disabled="false">
            <cargo-advance-select
              no="branchId"
              :select-type="selectTypeNames.basic_data_Office_All"
              :clearable="false"
              filterable
              :disabled="true"
              :default-value="form.branchId||''"
              :placeholder="' '"
              @parentCallBack="p => handleCompany(p)"
            />
          </el-form-item>
          <el-form-item v-if="form.generativeRule === SystemConstants.GENERAL.code" :label="this.$t('CargoMsg.ApplicableDepartment')">
            <cargo-advance-select
              no="departmentId"
              :select-type="selectTypeNames.basic_data_Department"
              :allow-create="true"
              filterable
              :cache="false"
              :static-options="departmentArray"
              @parentCallBack="p=>{form.department = p.departmentId}"
            />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_Acquirer')">
            <cargo-user-select
              no="recipientId"
              :method-params="{officeId:$store.getters.currentOfficeId}"
              :merge-load="true"
              @change="item=>form.userId=item.value"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect'
import { registerFunc } from '@/api/booking/mblManagement'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getOfficeConfigByName } from '@/api/user'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cacheKeys, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { FIXED_LAST_NUMBER, GENERAL } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'RegisterWindow',
  components: { CargoAdvanceSelect, CargoOwnedBranchSelect, cargoUserSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      prefix: '',
      rules: [],
      checkNoRule: true,
      generativeRules: SystemConstants.GENERATIVE_RULES,
      officeList: [],
      departmentArray: [],
      form: {
        carrierId: 0,
        bookingAgent: 0,
        generativeRule: 1,
        starNo: '',
        endNo: '',
        number: 0,
        remark: '',
        userId: 0,
        branchId: this.$store.getters.currentOfficeId,
        department: 0,
        currentBranchId: this.$store.getters.currentOfficeId
      }
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
    'form.generativeRule': {
      handler(newRule) {
        if (newRule === SystemConstants.GENERAL.code) {
          this.form.branchId = 0
        } else if (newRule === SystemConstants.FIXED_LAST_NUMBER.code) {
          this.form.branchId = this.$store.getters.currentOfficeId
        }
      },
      deep: true
    }
  },
  created() {
    this.initData()
  },
  mounted() {},
  methods: {
    initData() {
      getOfficeConfigByName({
        officeId: this.$store.getters.currentOfficeId,
        configName: 'SEMblNoPattern'
      }).then((res) => {
        this.rules = res.data.details
      })
    },
    getValueFromChild(obj) {
      this.form[obj.key] = obj.value
      this.prefix = ''
      if (this.rules && this.rules.length > 0) {
        for (const data of this.rules) {
          if (data.partnerId === obj.value) {
            this.prefix = data.value
          }
        }
      }

      if (this.prefix) {
        this.form.starNo = this.prefix
      }

      const branchIds = obj.multipleBranchId ? obj.multipleBranchId.split(',') : []
      const offices = []
      offices.push(obj.branchId)
      offices.push(...branchIds)
      const officesAsNumbers = offices.map(Number)
      this.officeList = getFilterCacheList(basicCacheKeys.basic_data_Office_All, p => officesAsNumbers.includes(p.officeId))
    },
    endNoChangeHandler(e) {
      this.checkNoRule = false
      if (e) {
        const starNum = this.getMiddleData(this.form.starNo)
        const endNum = this.getMiddleData(e)
        if (Number(starNum) > 0 && Number(endNum) > 0 && Number(endNum) > Number(starNum)) {
          this.form.number = endNum - starNum + 1
          this.checkNoRule = true
        }
      }
    },
    numberChangeHandler(e) {
      if (e === undefined) {
        this.form.endNo = ''
        this.checkNoRule = true
        return
      }
      // 需要排除掉起始单数量
      const number = e - 1
      this.checkNoRule = false
      // 通用规则不必须校验前缀，配了主单号规则则校验，没配则不校验
      if (this.form.starNo || this.form.generativeRule === SystemConstants.GENERAL.code) {
        const value = this.getMiddleData(this.form.starNo)
        if (Number(value) > 0) {
          if (this.form.generativeRule === SystemConstants.FIXED_LAST_NUMBER.code) {
            this.form.endNo = this.prefix + '' + String(Number(value) + number).padStart(value.length, '0') + '00'
          } else if (this.form.generativeRule === SystemConstants.GENERAL.code) {
            if (this.prefix) {
              this.form.endNo = this.prefix + '' + String(Number(value) + number).padStart(value.length, '0')
            } else {
              const prefix = this.form.starNo.substring(0, this.form.starNo.length - value.length)
              this.form.endNo = prefix + '' + String(Number(value) + number).padStart(value.length, '0')
            }
          }
          this.checkNoRule = true
        }
      }
    },
    getMiddleData(value) {
      const isRuleOne = this.form.generativeRule === SystemConstants.FIXED_LAST_NUMBER.code
      const isRuleTwo = this.form.generativeRule === SystemConstants.GENERAL.code
      if (isRuleOne) {
        const mantissa = value.slice(-2)
        // 尾数必须是00
        if (mantissa !== '00') {
          return -1
        }
      }
      if (isRuleOne || (isRuleTwo && this.prefix)) {
        // 前缀必须相同
        const valuePrefix = value.slice(0, this.prefix.length)
        if (valuePrefix !== this.prefix) {
          return -2
        }
        // 去除前缀
        let result = value.slice(this.prefix.length)
        if (isRuleOne) {
          // 去除后缀00
          result = result.replace(/00$/, '')
        }
        const data = Number(result)
        // 中间的必须是数字
        if (String(data) !== 'NaN') {
          // 返回字符串
          return result
        } else {
          return -3
        }
      }
      if (isRuleTwo && !this.prefix) {
        // 提取字符串尾部的数字部分
        const match = value.match(/\d+$/)
        if (match) {
          return match[0] // 返回匹配的数字
        } else {
          return -1 // 如果没有数字，则返回 -1
        }
      }
    },
    saveHandler() {
      if (!this.form.carrierId || this.form.carrierId === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectCarrier'))
        return
      }
      if (!this.checkNoRule) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NumberErrTip2'))
        return
      }
      if (!this.form.starNo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_StartNumber'))
        return
      }
      if (!this.form.endNo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_EndNumber'))
        return
      }
      if (!this.form.number) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_TotalCopies'))
        return
      }
      if (!this.form.branchId) {
        this.$message.warning(this.$t('CargoMsg.PleaseSelectApplicableBranch'))
        return
      }
      this.fullscreenLoading = getLoading4Cxt()
      registerFunc(this.form).then((res) => {
        const data = res.data
        if (data === 'ok') {
          this.innerVisible = false
          this.$emit('queryList')
        } else if (data === 'prefixTip') {
          this.$message.warning(this.$t('CargoMsg.Cargo_PrefixTip'))
        } else if (data === 'starTip') {
          this.$message.warning(this.$t('CargoMsg.Cargo_StarTip'))
        } else if (data === 'starNoTip') {
          this.$message.warning(this.$t('CargoMsg.Cargo_StarNoTip'))
        } else {
          this.$alert(this.$t('CargoMsg.Cargo_AlreadyExistTip', [data]), this.$t('common.tips.prompt'), {
            dangerouslyUseHTMLString: true,
            showClose: false,
            confirmButtonText: this.$t('common.btn.close'),
            type: 'warning'
          })
        }
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    handleCompany(data) {
      this.form.branchId = data.value
      const officeUuid = data.uuid
      let currentDeptList = []
      if (this.form.branchId && Number(this.form.branchId) === 1) { // 总部的话取所有部门
        currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department_All, null) || []
      } else {
        currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
          return item.officeUuid === officeUuid
        }) || []
      }
      this.departmentArray = currentDeptList
    }
  }
}
</script>

